import React, { useContext, useEffect, useState, useRef } from 'react'
import SearchBarNew from '../../Components/Custom/UI/SearchBarNew'
import ProfessionalCard from '../../Components/Custom/UI/ProfessionalCard'
import NewServiceCard from '../../Components/Custom/UI/NewServiceCard'
import '../../CSS/UI Components/ServiceListingPageAtHome.css'
import { useMediaQuery } from "react-responsive"
import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import AllServicesIcon from '../../Assets/AllServices.png'
import filtersIcon from '../../Assets/filterIcon.png'
import StarIconGreen from '../../Assets/material-symbols-star-rounded.png'
import ratingsIcon from '../../Assets/ratingsIcon.png'
import discountIcon from '../../Assets/discountIcon.png'
import filterIcon_white from '../../Assets/filterIcon_white.png'
import ratingsIcon_white from '../../Assets/ratingsIcon_white.png'
import discountIcon_white from '../../Assets/discountIcon_white.png'
import DropdownIcon from '../../Assets/dropdown_black.png'
import dropDown_filter from '../../Assets/dropdown_white.png'
import { catImages, subcatImages } from '../../Components/CatIcons';
import subcat_img from '../../Assets/subcat_img.png'
import FilterArrowUp from '../../Assets/filters_arrow_up.png'
import FilterArrowDown from '../../Assets/filters_arrow_down.png'
import crossIcon from '../../Assets/crossIcon.png'
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import TimePicker from 'react-time-picker';
import moment from 'moment'
import momenttz from "moment-timezone"
import { globalState } from '../../GlobalState/globalState'
import calendarIcon from '../../Assets/calendarIcon.png'
import timeIcon from '../../Assets/timeIcon.png'
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { Range } from 'react-range';
import numeral from 'numeral';
import curr from 'currency.js';
import { ToastContainer, toast } from 'react-toastify';
import customFetchData from '../../Components/Custom/customFetchData';
import { catColors } from '../../Components/Custom/UI/Colors'
import { ClipLoader } from 'react-spinners';
import {Helmet} from "react-helmet";
import useDebounce from '../../Components/Custom/Hooks/useDebounce'
import CloseIcon from '../../Assets/icons-closeModal.png'
import ServiceDetails from '../../Components/Custom/UI/AtHomeServiceDetails';
import { toCategorySlug, toSubCategorySlug, toProNameSlug, slugToCatName, slugToSubCatName } from '../../Navigation/NavigationSlug';
// import "react-datepicker/dist/react-datepicker-cssmodules.css";
// import '../../../../node_modules/react-datepicker/dist/react-datepicker.css';
import { Container, Row, Col, Card, CardBody, CarouselItem, Carousel, Navbar, CarouselIndicators, Modal, ModalFooter, ModalHeader, ModalBody, Collapse, FormGroup } from 'reactstrap'
import { clearAddress, clearServices, storeAddress, storeDateAndTime, storeServices } from '../../GlobalState/globalStateActions'
import FetchCurrentLocation from '../../Components/Custom/FetchCurrentLocation'
import NewProfessionalCard from '../../Components/Custom/UI/NewProfessionalCard'
import BookAserviceWithUs from '../../Components/Custom/UI/BookAserviceWithUs'
const DeepClone = require("rfdc/default")
export default function ProfessionalUnderCategory() {
    const MobileAndBelowMediaQuery = () => useMediaQuery({ query: "(max-width: 760px)" })
    const TabletMediaQuery = () => useMediaQuery({ minWidth: 768, maxWidth: 991 })
    const isTabView = TabletMediaQuery()
    const MobileAndTabletMediaQuery = () => useMediaQuery({ minWidth: 0, maxWidth: 769 })
    const isTabMob=MobileAndTabletMediaQuery()
    const [routesArr,setRoutesArr]=useState([])        
    const isMobileView = MobileAndBelowMediaQuery();
    const [state, dispatch] = useContext(globalState)
    const paramsLocation = useLocation()
    const navigate = useNavigate()
    const [categoryName, setCategoryName] = useState(paramsLocation.state ? (paramsLocation.state.catItem ? paramsLocation.state.catItem.category_name : '') : '')
    const [filteredNearByPros, setFilteredNearByPros] = useState([])
    const [mpidArr, setMpidArr] = useState([])
    const [catMpidArr, setCatMpidArr] = useState([])
    const [searchDropdownArray, setSearchDropdownArray] = useState([])
    const [showSearchDropDown, setShowSearchDropDown] = useState(false)
    const [catPrid, setCatPrid] = useState(null)
    const [filteredSubCats, setFilteredSubCats] = useState([])
    const [subCatPrid, setSubCatPrid] = useState(null)
    const [subLoading, setSubLoading] = useState(true)
    const [proLoading, setProLoading] = useState(true)
    const [didClearSearch, setDidClearSearch] = useState(false)
    const [clickOnAtHome, setClickOnAtHome] = useState(true)
    const [searchSamePage, setSearchSamePage] = useState(false)
    const [searchModalOpen, setSearchModalOpen] = useState(false)
    const [recentSearchesArray, setRecentSearchesArray] = useState([])
    const [recentResultsNotFound, setRecentResultsNotFound] = useState(false)
    const [reviewCount, setReviewCount] = useState(10)
    const [catRating, setCatRating] = useState(4)
    const [displayCount, setDisplayCount] = useState(0)
    const [catVideoLink, setCatVideoLink] = useState('')
    const scrollRef = useRef(null);
    const [serviceDetails,setServiceDetails]=useState({})
    const [enableButton, setEnableButton] = useState(false);
    const [contentHeight, setContentHeight] = useState(0);
    const [scrollViewHeight, setScrollViewHeight] = useState(0);
    const [enableHeader, setEnableHeader] = useState(false)
    const [randomRating, setRandomRating] = useState(4.5)
    const [showPrevious, setShowPrevious] = useState(false)
    const [noResSearchCard, setNoResSearchCard] = useState("")
    const [searchRequested, setSearchRequested] = useState(false)
    const [serviceSearchPros, setServiceSearchPros] = useState([])
    const [serviceSearched, setServiceSearched] = useState(false)
    const [latestBookings, setLatestBookings] = useState([])
    const [searchTextService, setSearchTextService] = useState('')
    const [clickOnServiceSearch, setClickOnServiceSearch] = useState(false)
    const lookingForItems = [
        { id: '1', image: 'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1747724297838-lg.webp', label: 'Clean Up/ Masques' },
        { id: '2', image: 'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1747724297838-lg.webp', label: 'Men fsdfdsfd djsjjj' },
        { id: '3', image: 'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1747724297838-lg.webp', label: 'Couples fdfdsfdf 000' },
        { id: '4', image: 'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1747724297838-lg.webp', label: 'Kids' },
        { id: '5', image: 'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1747724297838-lg.webp', label: 'Pre-wedding' },
        { id: '6', image: 'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1747724297838-lg.webp', label: 'Bridal' },
    ]
    const [offerData,setOfferData] = useState([])
        
    const [selectedFilters, setSelectedFilters] = useState({
        women: false,
        men: false,
        kids: false,
    });
    const [services, setServices] = useState([])
    const [filteredServices, setFilteredServices] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [serSearchProsLoading, setSerSearchProsLoading] = useState(false)
    const [cartAmount, setCartAmount] = useState(0)
    const [unlockedVisitationFee, setUnlockedVisitationFee] = useState(false)
    const [pullToRefreshDone, setPullToRefreshDone] = useState(false)
    const [address, setAddress] = useState({})
    const [locationLoader, setLocationLoader] = useState(true)
    const [catAndProLoader, setCatAndProLoader] = useState(true)
    const [filteredArray, setFilteredArray] = useState([])
    const [subcategoryServicesMap, setSubcategoryServicesMap] = useState({})
    const [filteredSubcategoryServicesMap, setFilteredSubcategoryServicesMap] = useState({})
    const [catMinBookingValue, setCatMinBookingValue] = useState(0);
    const [catCurrency, setCatCurrency] = useState('');
    const [minBookingNotReached, setMinBookingNotReached] = useState(false);
    const [catCartAmount, setCatCartAmount] = useState(0);
    const [lowestPricedService, setLowestPricedService] = useState(null);
    const view2Ref = useRef(null);
    const [searchTextOffer, setSearchTextOffer] = useState("")
        const [nearByPros, setNearByPros] = useState([])
        const [categories, setCategories] = useState([])
        const [subCategories, setsubCategories] = useState([])
        const [activeIndex, setActiveIndex] = useState(0);
        const [subcategories, setSubcategories] = useState([])
        const [filtersModal, setFiltersModal] = useState(false)
        const [sortRatings, setSortRatings] = useState(false)
        const [sortDiscount, setSortDiscount] = useState(false)
        const [dateCollapsed, setDateCollapsed] = useState(true)
        const [timeCollapsed, setTimeCollapsed] = useState(true)
        const [priceCollapsed, setPriceCollapsed] = useState(true)
        const [distanceCollapsed, setDistanceCollapsed] = useState(true)
        const [distanceMin, setDistanceMin] = useState(state.distanceMin)
        const [distanceMax, setDistanceMax] = useState(state.distanceMax)
        const [ratingsMin, setRatingsMin] = useState(0)
        const [ratingsMax, setRatingsMax] = useState(5)
        const [priceMin, setPriceMin] = useState(0)
        const [priceMax, setPriceMax] = useState(state.address.country === 'India' ? 15000 : 5000)
        const [male, setMale] = useState(false)
        const [both, setBoth] = useState(false)
        const [checked, setChecked] = useState([])
        const [selectedCatPrid, setSelectedCatPrid] = useState(0)
        const [onClickReset, setOnClickReset] = useState(false)
        const [country, setCountry] = useState('IN')
        const [isDateTimePickerVisible, setIsDateTimePickerVisible] = useState(false)
        const [isDateTimePickerVisible1, setIsDateTimePickerVisible1] = useState(false)
        const [isDateTimePickerVisible2, setIsDateTimePickerVisible2] = useState(false)
        const [isDateTimePickerVisible3, setIsDateTimePickerVisible3] = useState(false)
        const [fromDateTime, setFromDateTime] = useState('')
        const [toDateTime, setToDateTime] = useState('')
        const [mindate, setMindate] = useState('')
        const [selectedBTimes, setSelectedBTimes] = useState({ fromTime: moment().set({ 'hour': 0, 'minute': 0 }), toTime: moment().set({ 'hour': 23, 'minute': 59 }) })
        const [fromHours, setFromHours] = useState('')
        const [toHours, setToHours] = useState('')
        const [subcatCheck, setSubcatCheck] = useState({})
        const [searchClickedValue, setSearchClickedValue] = useState("")
        const [clickOnOfferSearch, setClickOnOfferSearch] = useState(false)
        const [merchantTimeZone, setMerchantTimeZone] = useState(state.country.timezone)
        const [applyButtonLoading, setApplyButtonLoading] = useState(false)
        const [calFilteredOffers, setCalFilteredOffers] = useState('')
        const [onApplyClick, setOnApplyClick] = useState(false)
        const [onApplyClick2, setOnApplyClick2] = useState(false)
        // const [mpidArr, setMpidArr] = useState(['1473, 1640, 1713,1714,1715,1716,1718,1720,1729,1730,1734,1750,1759,1760,1766,1768,1770,771,1772,1773,1777, 788,1790,1797,1851,1885,1905,1906,1909,1912,1911,1921,1923,1927,1930,1934,1941,1944,1945,1952,2033,2035,2036,2052,2087,2088,2097,2099, 2100,2104,2105,2110,2114,2121,2118,22102,22159,22161,22171,22181,21731,21732,21745,21747, 21751,21753,21754, 21758,21762,21765,21764,21774,21795,21798,21896,21898,21907,21908,21928,21929,21938,21940,21942,21943,21955,21961,21963, 22022,22021, 2028,2030,2055,2086,2103,2106,2107,1722,1725,1726,1727,1728,1740, 1763,1767,1776, 1628,1789,1796,2077,2083,2084,1783,1939,2119'])
        const [prevFilters, setPrevFilters] = useState({})
        const [bannerImage, setBannerImage] = useState('')
        const [cityNotYet, setCityNotYet] = useState(false)
        const [loadingCat,setLoadingCat]=useState(true)
        const [searchParams, setSearchParams] = useSearchParams()
        const [titleOptions,setTitleOptions] = useState([])
        const [subCatName, setSubCatName] = useState('')
        const [serviceName,setServiceName] = useState('')
        const [serviceDetailsModal, setServiceDetailsModal] = useState(false)

        // const debouncedSearchText = useDebounce(searchTextOffer, 500);
    const subcategoryRefs = useRef({}); // Store refs for each subcategory
    let searchUrl = paramsLocation.search
    let merchantTimezoneL = state.country.timezone

    let title
    let MerchantItems = [
        {
            key: 1,
            src: {
                // web:NewImageMer,
                // mobile:NewImageMerMobile
            },
            altText: (
                <div>
                    {/* <div style={{position:'absolute'}}>
                  <NewNavbarWebsite/>
              </div> */}
                    <div style={{ top: '45%', left: '10%', right: '15%', position: 'absolute', display: 'flex', flexDirection: 'column', zIndex: 10 }}>
                        {/* <div className="textStyle_sv2"> */}
                        <text className='serviceText_sv2_slp'>Are you looking for services ?</text>
                        <text className='serviceTextDesc_sv2_slp'>Explore top deals and offers exclusively for you</text>
                        {/* </div> */}
                    </div>
                </div>
            ),
        },
    ]
    let MerchantSlides = MerchantItems.map((item) => {
        return (

            <CarouselItem
                // onExiting={this.onExiting}
                // onExited={this.onExited}
                key={item.key}
            >
                <div className="CarousalContainer_Sv3_Slp">
                    {item.altText}

                    {/* <img className='imgStylesv2_puc' src={bannerImage} /> */}
                    {/* <img src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1666875231964-lg.jpg'} className='Carousal_policy_mobile'/> */}
                </div>
            </CarouselItem>

        );
    });
    let header = {
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'space-between',
        // marginHorizontal: 30,
        marginTop: 25,
    }
    let dateStyle = {
        fontFamily: 'Inter',
        fontSize: 16,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#747474'
    }
    let dateViewStyle = {
        borderRadius: 5,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e1e1e1",
        marginHorizontal: 30,
        marginTop: 20,
        padding: 12,
    }
    let timeViewStyle = {
        borderRadius: 5,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e1e1e1",
        marginHorizontal: 30,
        marginTop: 20,
        padding: 12,
    }
    let priceBox = {
        width: 75,
        // height: 28,
        borderRadius: 5,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e1e1e1",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0
    }
    let priceTextStyle = {
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: "300",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#000000"

    }
    let resetStyle = {
        width: '47%',
        height: 60,
        // padding:10,
        borderRadius: 10,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1.5,
        borderColor: 'rgb(140,82,255)',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer'
    }
    let updateStyle = {
        width: '47%',
        height: 60,
        borderRadius: 10,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1.5,
        borderColor: 'rgb(140,82,255)',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        backgroundColor: 'rgb(140,82,255)',
        cursor: 'pointer'

    }
    let ResetTextStyle = {
        // height: 19,
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        // textAlign: "center",
        color: 'rgb(140,82,255)'
    }
    let updateTextStyle = {
        // height: 19,
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        // textAlign: "center",
        color: '#fff'
    }
    let searchDropDowntextStyle = {
        fontFamily: "Inter",
        fontSize: 14,   
        fontWeight: "600",
        fontStyle: "normal",
        letterSpacing: 0,
        color: "#000000"
    }
    let searchDropDownSubtextStyle= {
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: "300",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#000000",
        marginTop: 2
    }
    useEffect(() => {
        console.log('serviceDetails in useEffect',serviceDetails)
        if (Object.keys(serviceDetails).length !== 0) {
            setServiceDetailsModal(true);
        }
    }, [serviceDetails]);
    useEffect(() => {
        //    console.log('state.user.id in puc:', route.params)
        console.log('paramsLocation.state in puc: before', paramsLocation.state)
        if (!paramsLocation.state) {
            console.log('No category data found in location state. Redirecting to home page.');
            let mpIdsArr = []
            let countryValueUseEffect = null;
            // console.log("inside useEffect PND isFocused", global.dynLinkValues)
            const dataFetch = async () => {
                try {
                    let mpidArr = []
                    let matched = null;
                    let city_data;
                        let locationDet = await FetchCurrentLocation(dispatch,false,state)
                        let { addressLine1, city, country, curr_location_latitude, curr_location_longitude, currentLocation, district, stateOrProvince, zipcode } = locationDet
                        setAddress(prevState => ({ ...prevState, addressLine1, city, country, curr_location_latitude, curr_location_longitude, currentLocation, district, stateOrProvince, zipcode }))
                        countryValueUseEffect = country
                        city_data = {
                            curr_city: city ? city : 'Hyderabad',
                            curr_lat: curr_location_latitude ? curr_location_latitude : 17.385044,
                            curr_long: curr_location_longitude ? curr_location_longitude : 78.486671,
                            stateOrProvince : stateOrProvince ? stateOrProvince : 'Telangana',
                            // curr_city:'Hyderabad',
                            // curr_lat:  17.463842,
                            // curr_long: 78.3446,
                            // stateOrProvince : 'Telangana',
                            // uniqueId: global.deviceUniqueId,
                            // deviceId: state.deviceId ? state.deviceId : null,
                        }
                    let { fetchedData } = await customFetchData('POST', city_data, '/website/fetchCurrentLocationPros/athome/sv2', state, dispatch)
                    console.log("offer data athome", fetchedData)
                    if (fetchedData.getOff) {
                        mpIdsArr = DeepClone(fetchedData.mpidArr)
                        setCategories(fetchedData.catsFinal)
                        setNearByPros(fetchedData.offers)
                        setFilteredArray(fetchedData.offers)
                        setMpidArr(fetchedData.mpidArr)
                        let regex = /[?&]([^=#]+)=([^&#]*)/g, searchParams = {}, match
                        while ((match = regex.exec(searchUrl))) {
                            searchParams[match[1]] = match[2]
                        }                             
                        if (Object.keys(searchParams).length > 0) {
                            // console.log('Matched category from deep link:', matched);
                            setCategoryName(searchParams.category);
                            setCatPrid(searchParams.categoryId);
                            fetchData(searchParams.category, searchParams.categoryId, fetchedData.mpidArr);
                        } else {
                            // If no matched category, fallback to global.dynLinkValues
                            setCategoryName('');
                            setCatPrid('');
                            setServices([])
                            setFilteredSubCats([])
                            setFilteredServices([])
                            setSubLoading(false)
                            setProLoading(false)
                            setNearByPros([])
                            setFilteredNearByPros([])
                            setDisplayCount(10)
                            setReviewCount(10)
                            setCatVideoLink({ previewLink: 'https://slash-hyd-video-streaming.s3.ap-south-2.amazonaws.com/Category+Videos/at+home+banner.mp4', poster: { source: { uri: "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753851823467-lg.png" } } })
                            setRandomRating(4.5)
                            setCatRating(4.5)
                            setIsLoading(false)



                        }
                    }
                    else {
                        setCategories([])
                        setNearByPros([])
                        setFilteredArray([])
                        setMpidArr([])
                    }
                }
                catch (c1) {
                    console.log(c1)
                }
            }

            (async () => {
                await dataFetch()
            })()
        }
    }, [paramsLocation.state])
    const onPressWomen = () => {
        setSelectedFilters(prev => ({ ...prev, women: !prev.women }));
    };
    const onPressMen = () => {
        setSelectedFilters(prev => ({ ...prev, men: !prev.men }));
    };
    const onPressKids = () => {
        setSelectedFilters(prev => ({ ...prev, kids: !prev.kids }));
    };
     useEffect(() => {
        if (paramsLocation.state) {
            fetchData()
        }
        // onload(params.catPrid)
        setSearchTextOffer('')
        setShowSearchDropDown(false)
    }, [])
    useEffect(() => {
        let filtered = DeepClone(services);
        let finalFiltered = [];

        if (subCatPrid) {
            finalFiltered = filtered.filter(item => item.QF_SERVICE_SUB_CATEGORY_PRID === subCatPrid);
        }
        else {
            finalFiltered = DeepClone(filtered);
        }

        const { women, men, kids } = selectedFilters;

        if (women || men || kids) {
            let servicesLocal = DeepClone(finalFiltered)
            finalFiltered = servicesLocal.filter(item => {
                let match = false;
                if (women && item.SERVICE_GENDER == 'Women') match = true;
                if (men && item.SERVICE_GENDER == 'Men') match = true;
                if (kids && item.AT_HOME_SERVICE_NAME && item.AT_HOME_SERVICE_NAME.toLowerCase().includes("kids")) match = true;
                return match;
            });
        }
        setFilteredServices(finalFiltered);
    }, [selectedFilters, services, subCatPrid]);
    const fetchData = async (categoryName, catPrid, mpidArr) => {
        let body = {}
        setIsLoading(true)
        if (!paramsLocation.state) {
            console.log('No paramsLocation.state, using local state values or defaults')
            if ((paramsLocation.state && paramsLocation.state.catItem)) {
                setCategoryName(paramsLocation.state && paramsLocation.state.catItem.category_name ? paramsLocation.state.catItem.category_name : categoryName)
                setCatPrid(paramsLocation.state && paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID ? paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID : catPrid)
                setMpidArr(paramsLocation.state && paramsLocation.state.mpidArr ? paramsLocation.state.mpidArr : mpidArr)
                setServiceSearched(paramsLocation.state && paramsLocation.state.fromServiceSearch ? true : false)

            } else {
                setCategoryName(categoryName)
                setCatPrid(catPrid)
                setMpidArr(mpidArr)
                // setServiceSearched(params && params.fromServiceSearch ? true : false)
            }
             if ((paramsLocation.state && paramsLocation.state.catItem)) {
                body = {
                    mpidArr: paramsLocation.state && paramsLocation.state.mpidArr ? paramsLocation.state.mpidArr : mpidArr,
                    catId: paramsLocation.state && paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID ? paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID : catPrid,
                    catName: paramsLocation.state && paramsLocation.state.catItem.category_name ? paramsLocation.state.catItem.category_name : categoryName,
                    country: state.address.country || 'India'

                }
            }
            else {
                body = {
                    mpidArr: mpidArr,
                    catId: catPrid,
                    catName: categoryName,
                    country: state.address.country || 'India'
                }
            }
        }else if(paramsLocation.state){
            console.log('paramsLocation.state', paramsLocation.state)
            body = {
                // mpidArr: global.atHomeMpIdsArr ? global.atHomeMpIdsArr : [],
                // catId: params.catItem.QF_SERVICE_CATEGORY_PRID,
                // cprid: state.user.id,
                // catName: params.catItem.category_name,
                // country: state.address.country || null
                mpidArr: paramsLocation && paramsLocation.state.mpidArr ? paramsLocation.state.mpidArr : mpidArr,
                catId: paramsLocation && paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID ? paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID : catPrid,
                catName: paramsLocation && paramsLocation.state.catItem.category_name ? paramsLocation.state.catItem.category_name : categoryName,
                country: state.address.country || 'India'
            }
        }
        // console.log('body in website/fetch/allAtHomeServices/sv1', body)
        let proFetchData = await customFetchData('POST', body, '/website/fetch/allAtHomeServices/sv1', state, dispatch)
        console.log('proFetchData', proFetchData)
        if (proFetchData.fetch) {
            if (proFetchData.fetchedData.data && (proFetchData.fetchedData.subcategories.length > 0 || proFetchData.fetchedData.services.length > 0)) {
                setFilteredSubCats(proFetchData.fetchedData.subcategories)
                setServices(proFetchData.fetchedData.services)
                setFilteredServices(proFetchData.fetchedData.services)
                setSubLoading(false)
                setProLoading(false)
                setIsLoading(false)
                setDisplayCount(proFetchData.fetchedData.displayCount)
                setReviewCount(proFetchData.fetchedData.reviewCount)
                setCatVideoLink(proFetchData.fetchedData.catVideoLink)
                setCatRating(proFetchData.fetchedData.catRating)
                setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                setSubcategoryServicesMap(proFetchData.fetchedData.subcategoryServicesMap || {})
                setFilteredSubcategoryServicesMap(proFetchData.fetchedData.subcategoryServicesMap || {})
                if (proFetchData.fetchedData.offerData && proFetchData.fetchedData.offerData.length > 0) {
                    setOfferData(proFetchData.fetchedData.offerData)
                }
                if (proFetchData.fetchedData.minServicePrice) {
                    setLowestPricedService(proFetchData.fetchedData.minServicePrice);
                }


                let services = [], subcatNames = [];
                proFetchData.fetchedData.subcategories.map(item => {
                    if (item.service_sub_category_name) {
                        subcatNames.push(item.service_sub_category_name)
                    }
                })
                proFetchData.fetchedData.services.map(item => {
                    if (item.AT_HOME_SERVICE_NAME) {
                        services.push({AT_HOME_SERVICE_NAME:item.AT_HOME_SERVICE_NAME, QF_AT_HOME_SERVICE_PRID:item.QF_AT_HOME_SERVICE_PRID})
                    }
                })
            }
            else {
                setServices([])
                setFilteredSubCats([])
                setFilteredServices([])
                setSubLoading(false)
                setProLoading(false)
                setFilteredNearByPros([])
                setDisplayCount(10)
                setReviewCount(10)
                setCatVideoLink(proFetchData.fetchedData.catVideoLink)
                setIsLoading(false)
                setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                if (proFetchData.fetchedData.offerData && proFetchData.fetchedData.offerData.length > 0) {
                    setOfferData(proFetchData.fetchedData.offerData)
                }
            }
        }
        else {
            setFilteredSubCats([])
            setSubLoading(false)
            setProLoading(false)
            setFilteredNearByPros([])
            setDisplayCount(10)
            setReviewCount(10)
            setCatVideoLink({ previewLink: 'https://slash-hyd-video-streaming.s3.ap-south-2.amazonaws.com/Category+Videos/at+home+banner.mp4', poster: { source: { uri: "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753851823467-lg.png" } } })
            setIsLoading(false)
            setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
        }
        
    }
    const next = () => {
        // if (animating) return;
        const nextIndex = activeIndex === MerchantItems.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        // if (animating) return;
        const nextIndex = activeIndex === 0 ? MerchantItems.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };
    const goToIndex = (newIndex) => {
        //   console.log("newIndex",newIndex)
        // if (this.animating) return;
        setActiveIndex(newIndex);

    }
    
    // Sub-Categories display
    let subItems;
    if (filteredSubCats.length !== 0) {
        subItems = (
            <>
                {

                    filteredSubCats.map((item, index) => {
                        return (
                            <div onClick={() => onPressSubCategory(item.QF_SERVICE_SUB_CATEGORY_PRID, item.service_sub_category_name)  } className='subitem_div_sv2' style={{border:item.QF_SERVICE_SUB_CATEGORY_PRID === subCatPrid ? '2px solid #8c52ff': '',padding:'8px',marginRight:30,width:isMobileView ? '100%' : undefined}} >
                                {/* <div className='sub-catimg_sv2' style={{ backgroundColor: catColors[item.category_name] }}> */}
                                <img className= {isMobileView ? 'subcat-img' : 'subcat_img-displayy'}  src={subcatImages[item.service_sub_category_name.trim()] ? subcatImages[item.service_sub_category_name.trim()] : 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753780019158-lg.webp'} />
                                {/* </div> */}
                                <text style={{ textAlign: 'center' }} className={ isMobileView ? 'sub_name_sv2_slp_mobile' : 'sub_name_slp_sv2'}>{item.service_sub_category_name}</text>
                            </div>
                        )
                    })
                }
            </>
        )

    }
    else {
        if (subLoading && filteredSubCats.length == 0) {
            subItems = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>No sub categories found.</text>
                </div>
            )
        }
    }
    // console.log('params location',paramsLocation.state)
    let proCards;
    if (services.length !== 0) {
        if (filteredServices.length !== 0) {

            proCards = (
                filteredServices.map((item, index) => {
                    return (
                        

                            isMobileView ?
                            <div className='proCardWidth_sv2'>
                                <NewServiceCard state={state} serviceData={item}  onPressCard={()=>NavToserviceDetails_Mobile(item)}/>
                            </div>
                            :
                            <div className='proCardWidth_sv2'>
                                <NewServiceCard state={state} serviceData={item}  onPressCard={()=>serviceDetailsModalShow(item)} />
                            </div>
                        
                         
                    )
                })
            )
        }
        else {
            proCards = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>Currently there are no Professionals for the selected filters. Please change the filters and try again.</text>
                </div>
            )
        }
    }
    else {
        if (nearByPros.length == 0 && proLoading) {
            proCards = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>No Professionals found</text>
                </div>
            )

        }
    }
    let proCardsMobile;
    if (filteredServices.length !== 0) {
        if (filteredServices.length !== 0) {

            proCardsMobile = (
                filteredServices.map((item, index) => {
                    return (
                        <div className='proCardWidth_sv2'>
                            <NewServiceCard state={state} serviceData={item} onPressCard={()=>NavToserviceDetails_Mobile(item)} />
                        </div>
                    )
                })
            )
        }
        else {
            proCardsMobile = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>Currently there are no Professionals for the selected filters. Please change the filters and try again.</text>
                </div>
            )
        }
    }
    else {
        if (filteredServices.length == 0 && proLoading) {
            proCardsMobile = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>No Professionals found</text>
                </div>
            )

        }
    }
    const onPressSubCategory = (item,subcatName) => {
        const ref = subcategoryRefs.current[subcatName];
        // console.log('ref for subcategory', ref, scrollRef.current,subcatName)
        setSubCatName(subcatName)
        scrollToSubCategory(subcatName)
        const servicesLocal = DeepClone(services)
        if (subCatPrid == item) {
            setFilteredServices(servicesLocal);
            setSubCatPrid(null);
        } else {
            const filtered = servicesLocal.filter(proArr => {
                return proArr.QF_SERVICE_SUB_CATEGORY_PRID == item
            });
            setFilteredServices(filtered);
            setSubCatPrid(item);
        }
        // console.log('subcat item pressed', item)
    }
    const clearSearchResults = (fromBack) => {
        if (fromBack) {
            setSearchModalOpen(false)
        }
        setSearchTextOffer("")
        setShowSearchDropDown(false)
        // setCategoryName(route.params ? (route.params.catItem ? route.params.catItem.category_name : '') : '')
        setCategoryName(paramsLocation.state && paramsLocation.state.catItem ? paramsLocation.state.catItem.category_name : '')
        setCatPrid(paramsLocation.state && paramsLocation.state.catItem ? paramsLocation.state.catItem.QF_SERVICE_CATEGORY_PRID : '')
        setSearchDropdownArray([])
        setFilteredSubcategoryServicesMap(subcategoryServicesMap); 
    }
    const searchBoxServiceHandler = (value) => {
        try {
            // console.log("value", value)
            setSearchTextService(value)
            let filteredOffers = DeepClone(filteredArray), matchesArr = []
            value = value ? value.trim() : value
            if (value.length > 2) {
                setShowSearchDropDown(true)
                // console.log("filtered", filteredOffers)
                filteredOffers.map((insideItem) => {
                    if (insideItem.SERVICE_NAME.search(new RegExp(value, 'i')) !== -1) {
                        matchesArr.push(insideItem)
                    }
                })

                matchesArr = matchesArr.filter((v, i, a) => a.findIndex(t => ((t.SERVICE_NAME === v.SERVICE_NAME))) === i)
                setSearchDropdownArray(matchesArr)
                // console.log("matchesArr", matchesArr);
            }
            else {
                setShowSearchDropDown(false)
                setClickOnServiceSearch(false)
                if (!didClearSearch) {
                    setDidClearSearch(true)
                }
                setSearchDropdownArray([])
                // setFilteredArray(services)        
            }
        }
        catch (cErr) {
            console.log(cErr)
        }
    }
    const NavToserviceDetails_Mobile=(item)=>{
        console.log('item', item)
      navigate({pathname:`/servicedetails/${item.AT_HOME_SERVICE_NAME.replaceAll(/[&\/\\#, +()$~%.'":*?<>{}]/g, "")}` ,search:`serviceId=${item.QF_AT_HOME_SERVICE_PRID}`},{state:{serviceDetails:item}})
    }
    const serviceDetailsModalShow = (item) => {
        setServiceName(item.AT_HOME_SERVICE_NAME)
        // setServiceDetailsModal(true)
        setServiceDetails(item)
    }
    const serviceDetailsModalClose = () => {
        setServiceDetailsModal(false)
        setServiceDetails({})
        setServiceName('')
    }
    const onPressServiceCard = (item) => {

        if (paramsLocation.state) {

            if (paramsLocation.state.fromSearch || searchSamePage) {
                console.log('item', item)
                let offers;
                offers = nearByPros.filter(item1 => {
                    if (item1[0].QF_MERCHANT_PERSONNEL_PRID == item.QF_MERCHANT_PERSONNEL_PRID) {
                        return item1
                    }
                })
                // console.log('offers',offers)
                if (offers.length !== 0) {
                    navigate({ pathname: `/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ", "", "g")}`, search: `?proId=${item.QF_MERCHANT_PERSONNEL_PRID}` }, {
                        state: {
                            proData: item, offers: offers[0], singleService: item, catId: catPrid, fromPucWishList: true, proChecked: checked['checked_' + item.QF_MERCHANT_PERSONNEL_PRID] ? true : false,
                            categories: DeepClone(state.categories), subCategories: DeepClone(state.subcategories),
                            addressDetails:
                            {
                                totalAddress: state.address.totalAddress,
                                addressLine1: state.address.addressLine1,
                                country: state.address.country,
                                city: state.address.city,
                                stateOrProvince: state.address.stateOrProvince,
                                zipcode: state.address.zipcode,
                                district: state.address.district,
                                latitude: state.address.latitude,
                                longitude: state.address.longitude,
                                currentAddress: state.address.currentAddress,
                                searchAddress: state.address.searchAddress,
                                currentLocationDenied: state.address.currentLocationDenied
                            },
                            allServices: nearByPros
                        }
                    })

                }
            }
            else {
                console.log('item', item)
                let subId;
        //         if(item.hasAddons){
        //     navigation.navigate('AthomeServiceAddOnsDetails', { serviceDetails: item })
        // }else{
        //     navigation.navigate('AtHomeServiceDetailsPage', { serviceDetails: item })
        // }
                // navigate('/professionalPage', { state: { proData: item[0], offers: item, catId: catPrid, subcatId: subCatPrid, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item[0].QF_MERCHANT_PERSONNEL_PRID] ? true : false } })
                navigate({ pathname: `/servicedetails/${item.AT_HOME_SERVICE_NAME.replaceAll(" ", "", "g")}` }, {
                    state: {serviceDetails: item}                    
                })

            }
        }
        else {
            console.log('item', item)
            let subId;
            // navigate('/professionalPage', { state: { proData: item[0], offers: item, catId: catPrid, subcatId: subCatPrid, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item[0].QF_MERCHANT_PERSONNEL_PRID] ? true : false } })
            navigate({ pathname: `/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ", "", "g")}`, search: `?proId=${item.QF_MERCHANT_PERSONNEL_PRID}` }, {
                state: {
                    proData: item, offers: item, catId: catPrid, subcatId: subCatPrid, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item.QF_MERCHANT_PERSONNEL_PRID] ? true : false,
                    categories: DeepClone(state.categories), subCategories: DeepClone(state.subcategories),
                    addressDetails:
                    {
                        totalAddress: state.address.totalAddress,
                        addressLine1: state.address.addressLine1,
                        country: state.address.country,
                        city: state.address.city,
                        stateOrProvince: state.address.stateOrProvince,
                        zipcode: state.address.zipcode,
                        district: state.address.district,
                        latitude: state.address.latitude,
                        longitude: state.address.longitude,
                        currentAddress: state.address.currentAddress,
                        searchAddress: state.address.searchAddress,
                        currentLocationDenied: state.address.currentLocationDenied
                    },
                    allServices: nearByPros
                }
            })
        }

    }
    let serviceDetailsDisplayModal = (
        <Modal isOpen={serviceDetailsModal} size={'md'} toggle={() => serviceDetailsModalClose()} centered>
            <div style={{ padding: 16 }}>
                <div style={{ justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                    <div className='crossIcon_ViewPro' style={{ cursor: 'pointer' }}>
                        <img src={CloseIcon} style={{ width: 18, height: 18 }} onClick={() => serviceDetailsModalClose()} />
                    </div>
                </div>
                <div style={{ marginTop: 20 }}>
                    <ServiceDetails serviceDetailsProps={serviceDetails} />
                </div>
            </div>
        </Modal>
    )
    let servicesItem = null;
    if (services.length == 0 && filteredServices.length == 0 && !isLoading) {
        servicesItem = (
            <div style={{ alignItems: 'center', justifyContent: 'center', marginVertical: '20%' }}>
                <text style={{ textAlign: 'center', color: '#747474' }}>
                    Sorry, no services are available at the moment. Please check back later or try a different category.
                </text>
            </div>
        )
    } else if (filteredServices.length == 0 && !isLoading) {
        servicesItem = (
            <div style={{ alignItems: 'center', justifyContent: 'center', marginVertical: '20%' }}>
                <text style={{ textAlign: 'center', color: '#747474' }}>No services found for the selected filters</text>
            </div>
        )
    } else if (isLoading) {
        servicesItem = (
            <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <ClipLoader widthUnit={"%"} size={40} loadings={isLoading} color="#8c52ff" />
            </div>
        )
    }
    const onSearchServiceName = async (event) => {
        let value = event.target.value
        setSearchTextOffer(event.target.value)
        if (value.length > 2) {
            let allMatchedServices = [];
            let groupedSearchResults = {};
            console.log('subcategoryServicesMap', subcategoryServicesMap,value)
          Object.entries(subcategoryServicesMap).forEach(([catName, servicesArr]) => {
            const matchedServices = servicesArr.filter(service =>
              service.AT_HOME_SERVICE_NAME &&
              service.AT_HOME_SERVICE_NAME.toLowerCase().includes(value.toLowerCase())
            );
              allMatchedServices = allMatchedServices.concat(matchedServices);
          });
          console.log('allMatchedServices', allMatchedServices)
            if (allMatchedServices.length > 0) {
                setShowSearchDropDown(true);
                setSearchDropdownArray(allMatchedServices);
            } else {
                setShowSearchDropDown(true);
                setSearchDropdownArray([]);
            }
        }
        else {
            setShowSearchDropDown(false)
            setSearchDropdownArray([])
        }
    }
    const onPressSearchDropDown = async (data) => {
        // console.log('data on search dropdown click', data)
        setShowSearchDropDown(false)
        setSearchModalOpen(false)
        setSearchTextOffer(data.AT_HOME_SERVICE_NAME)

        // let filteredOffers = DeepClone(filteredServices), matchesArr = []

        // filteredOffers.map((insideItem) => {
        //     if (insideItem.AT_HOME_SERVICE_NAME === data.AT_HOME_SERVICE_NAME) {
        //         matchesArr.push(insideItem)
        //     }
        // })
        // console.log("matchesArr on click", matchesArr);
        // if (matchesArr.length !== 0) {
        //     setFilteredServices(matchesArr)
        // }
         let groupedSearchResults = {};
          Object.entries(subcategoryServicesMap).forEach(([catName, servicesArr]) => {
            const matchedServices = servicesArr.filter(service =>
              service.AT_HOME_SERVICE_NAME &&
              service.AT_HOME_SERVICE_NAME.toLowerCase().includes(data.AT_HOME_SERVICE_NAME.toLowerCase())
            );
            if (matchedServices.length > 0) {
              groupedSearchResults[catName] = matchedServices;
            }
            else{
              groupedSearchResults[catName] = [];
            }
          });
          // Remove keys with empty arrays
        Object.keys(groupedSearchResults).forEach(key => {
        if (!groupedSearchResults[key] || groupedSearchResults[key].length === 0) {
            delete groupedSearchResults[key];
        }
        });
        setFilteredSubcategoryServicesMap(groupedSearchResults);
    }
    const onCatSelection = async (cat_item) => {
        console.log('in cat selection cat_item', cat_item)
        setCatPrid(cat_item && cat_item.QF_SERVICE_CATEGORY_PRID)
        const params = paramsLocation.state || {};
        console.log('in cat selection params')
        console.log('params && params.mpidArr ? params.mpidArr : mpidArr,',params && params.mpidArr ? params.mpidArr : mpidArr,cat_item && cat_item.QF_SERVICE_CATEGORY_PRID, cat_item && cat_item.category_name)
        let body = {
            mpidArr: params && params.mpidArr ? params.mpidArr : mpidArr,
            catId: cat_item && cat_item.QF_SERVICE_CATEGORY_PRID,
            catName: cat_item && cat_item.category_name,
        }
        let proFetchData = await customFetchData('POST', body, '/website/fetch/allAtHomeServices/sv1', state, dispatch)
        console.log('proFetchData', proFetchData)
        if (proFetchData.fetch) {
            if (proFetchData.fetchedData.data && (proFetchData.fetchedData.subcategories.length > 0 || proFetchData.fetchedData.services.length > 0)) {
                setFilteredSubCats(proFetchData.fetchedData.subcategories)
                setServices(proFetchData.fetchedData.services)
                setFilteredServices(proFetchData.fetchedData.services)
                setSubLoading(false)
                setProLoading(false)
                setIsLoading(false)
                setDisplayCount(proFetchData.fetchedData.displayCount)
                setReviewCount(proFetchData.fetchedData.reviewCount)
                setCatVideoLink(proFetchData.fetchedData.catVideoLink)
                setCatRating(proFetchData.fetchedData.catRating)
                setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                setSubcategoryServicesMap(proFetchData.fetchedData.subcategoryServicesMap || {})
                setFilteredSubcategoryServicesMap(proFetchData.fetchedData.subcategoryServicesMap || {})
                if (proFetchData.fetchedData.offerData && proFetchData.fetchedData.offerData.length > 0) {
                    setOfferData(proFetchData.fetchedData.offerData)
                }
                if (proFetchData.fetchedData.minServicePrice) {
                    setLowestPricedService(proFetchData.fetchedData.minServicePrice);
                }


                let services = [], subcatNames = [];
                proFetchData.fetchedData.subcategories.map(item => {
                    if (item.service_sub_category_name) {
                        subcatNames.push(item.service_sub_category_name)
                    }
                })
                proFetchData.fetchedData.services.map(item => {
                    if (item.AT_HOME_SERVICE_NAME) {
                        services.push({AT_HOME_SERVICE_NAME:item.AT_HOME_SERVICE_NAME, QF_AT_HOME_SERVICE_PRID:item.QF_AT_HOME_SERVICE_PRID})
                    }
                })
            }
            else {
                setServices([])
                setFilteredSubCats([])
                setFilteredServices([])
                setSubLoading(false)
                setProLoading(false)
                setFilteredNearByPros([])
                setDisplayCount(10)
                setReviewCount(10)
                setCatVideoLink(proFetchData.fetchedData.catVideoLink)
                setIsLoading(false)
                setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                if (proFetchData.fetchedData.offerData && proFetchData.fetchedData.offerData.length > 0) {
                    setOfferData(proFetchData.fetchedData.offerData)
                }
            }
        }
        else {
            setFilteredSubCats([])
            setSubLoading(false)
            setProLoading(false)
            setFilteredNearByPros([])
            setDisplayCount(10)
            setReviewCount(10)
            setCatVideoLink({ previewLink: 'https://slash-hyd-video-streaming.s3.ap-south-2.amazonaws.com/Category+Videos/at+home+banner.mp4', poster: { source: { uri: "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753851823467-lg.png" } } })
            setIsLoading(false)
            setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
        }
    }
    let searchDropDownItems;
    if (services.length !== 0 && filteredServices.length !== 0 && showSearchDropDown) {
        if (searchDropdownArray.length !== 0) {
            searchDropDownItems = (
                // <FlatList
                //     data={searchDropdownArray}
                //     extraData={[searchDropdownArray]}
                //     keyExtractor={(item, index) => index.toString()}
                //     renderItem={_renderSearchDropdown}
                //     style={{ height: height1 - 80 }}
                //     keyboardShouldPersistTaps='handled'
                // />
                searchDropdownArray.map((item, index) => {
                    return (
                        <div onClick={() => onPressSearchDropDown(item)} style={{ backgroundColor: '#fff', padding: 20, borderBottomWidth: 1, borderBottomColor: 'rgba(216, 197, 252, 0.6)', display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                            <img src={item.image_link } style={{ width: 44, height: 44, borderRadius: 7 }} />
                            <div style={{ justifyContent: 'center', marginLeft: 22, display: 'flex', flexDirection: 'column' }}>
                                <text style={searchDropDowntextStyle}>{item.AT_HOME_SERVICE_NAME}</text>
                                <text style={searchDropDownSubtextStyle}>{"Service"}</text>
                            </div>
                        </div>
                    )
                })
            )
        }
        else {
            searchDropDownItems = (
                <div style={{ marginHorizontal: 60, marginTop: 120 }}>
                    <text>{"We couldn't find what you're looking for. Want to try something else?"}</text>
                    {/* <EmptyScreen buttonTrue={false} Title={'No results found!'} Description={"We couldn't find what you're looking for. Want to try something else?"} buttonName={'Suggest Us'} emptyImage={SearchImage} marginBottom={30} marginTop={height1 / 2 - 150} /> */}
                </div>
            )
        }
    }
    const scrollToSubCategory = (subcatName) => {
    const element = subcategoryRefs.current[subcatName];

    if (element) {
        const offset = 100; // Adjust based on your header height

        const top =
            element.getBoundingClientRect().top +
            window.pageYOffset -
            offset;

        window.scrollTo({
            top,
            behavior: 'smooth'
        });
    }
    };
    const showPlusForTens = (num,count) => {
        if (num < count) return num.toString();
        const base = Math.floor(num / count) * count;
        return `${base}+`;
    }
    console.log('slug deta', slugToCatName(searchParams[0]),searchParams[0])
    return (
        <div style={{ backgroundColor: '#e8e8e8' }}>                              
            <Helmet>
                <title>SLASH | {categoryName ? categoryName : (paramsLocation.state && paramsLocation.state.catItem && paramsLocation.state.catItem.category_name) ? paramsLocation.state.catItem.category_name : slugToCatName(searchParams[0])? slugToCatName(searchParams[0]) :''  } {subCatName ? `| ${subCatName}` : ''} {serviceName ? `| ${serviceName}` : ''} | {state.address.city}</title>
            </Helmet>
            <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
                ride="carousel"
                interval={2000}
            >
                {MerchantItems.length > 1 ? <CarouselIndicators className="carousel-indicators_Landing" items={MerchantItems} activeIndex={activeIndex} onClickHandler={() => goToIndex()} /> : null}
                {MerchantSlides}
            </Carousel>
            {
                cityNotYet ?
                    <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <text style={{textAlign:'center'}}> "We are not yet available in your city. Please check back later."</text>
                    </div>
                    :
            <>
                <div className='subdiv_sv2_slp'>
                    <div style={{ marginTop: 20,marginBottom:20 }} className='proDetail_cont1'>
                    <text className={isMobileView ? 'trustStyle_mobile': 'trustStyle'}>Trusted by {displayCount ? displayCount : '25k' + "+"} happy customers</text>
                    <text style={{marginTop:20}} className={isMobileView ? 'proNamee_style_mobile' : 'proNamee_style'}>{categoryName ? categoryName : paramsLocation.state ? (paramsLocation.state.catItem ? (paramsLocation.state.catItem.category_name).toUpperCase() : '') : ''}</text>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:15}}>
                    <div className='ratingContainer'>
                        <div className='ratingBadge'>
                            {/* <text className="ratingValue">{proData.MERCHANT_PERSONNEL_RATING ? numeral(proData.MERCHANT_PERSONNEL_RATING).format('0.0') : 4}</Text> */}
                            <text className={isMobileView ? "ratingValue_mobile" : "ratingValue"}>{catRating ? catRating : 4.5}</text>
                            <img src={StarIconGreen} style={{ width: 16, height: 16 }} />
                        </div>
                    </div>
                    {
                    <text className={isMobileView ? 'reviewTextStyle_mobile':'reviewTextStyle'}>{reviewCount + " Reviews"}</text>
                    }
                    </div>
                </div>
                    <div className= {isMobileView ? 'catdiv_sv2_slp_mobile' : 'catdiv_sv2_slp' }  >
                        {
                            categories.map(item => {
                                return (
                                    <div style={{
                                        height: 39, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex', padding: 12,marginRight:10,
                                        borderRadius: 20,
                                        border: 'solid 1px #747474',
                                        backgroundColor: catPrid == item.QF_SERVICE_CATEGORY_PRID ? '#8c52ff':'#fff'
                                    }} onClick={() => onCatSelection(item)} >
                                        {/* <div className='catmain_sv2' > */}
                                        {/* <img src={item.category_image} className='catImg_sv2' /> */}
                                        {/* </div> */}
                                        <text className={isMobileView ? 'AllServices_sv2_mobile' : 'AllServices_sv2' } style={{ fontWeight: catPrid === item.QF_SERVICE_CATEGORY_PRID ? 600 : 'normal',color:catPrid == item.QF_SERVICE_CATEGORY_PRID ? '#fff' : '#747474' }} > {item.category_name}</text>
                                    </div>

                                )
                            })
                        }
                    </div>
                    {/* <hr style={{ marginTop: -1, }} /> */}
                    {/* Search Input */}
                    <div className='searchBar_style_sv2' style={{width:isMobileView ? '100%':'75%'}}>
                        <SearchBarNew
                            type='text'
                            value={searchTextOffer}
                            placeholder="Search any Service / Professional / Category"
                            onChange={onSearchServiceName}
                            // returnType="done"
                            onClickCross={clearSearchResults}
                            searchTextService={searchTextOffer}
                            onSubmitEditing={clearSearchResults}
                        />
                        {showSearchDropDown ? <Card style={{ position: 'absolute', height: searchDropdownArray.length > 0 ? (searchDropdownArray.length === 1 || searchDropdownArray.length === 2 ? 'auto' : 220) : 150, top: 55, zIndex: 2000, width: '60%', overflow: 'auto' }}>
                            {searchDropDownItems}
                        </Card> : null}
                    </div>
                    {
                        subLoading ?
                            <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                <ClipLoader widthUnit={"%"} size={40} loadings={subLoading} color="#8c52ff" />
                            </div>
                            :
                            <div className={isMobileView ? 'subcat-grid' :'subcat_display_main'}>
                                {subItems}
                            </div>
                    }
                    {/* {
                        proLoading ?
                            <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                <ClipLoader widthUnit={"%"} size={40} loadings={proLoading} color="#8c52ff" />
                            </div>
                            :
                            isMobileView ?
                                <div style={{ width: '100%' }}>
                                    {proCardsMobile}
                                </div>
                                :
                                <div>
                                    {proCards}
                                </div>
                    } */}
                    {servicesItem}
                        <>
                            {
                                Object.keys(subcategoryServicesMap).length > 0 && Object.keys(filteredSubcategoryServicesMap).length!==0 ?
                                Object.keys(filteredSubcategoryServicesMap).map((subcatName, idx) => (
                                    <div key={subcatName}>
                                        {/* Attach ref ONLY to the header View */}
                                        <div
                                            ref={ref => { if (ref) subcategoryRefs.current[subcatName] = ref; }}
                                            style={{ marginBottom: 8 }}
                                        >
                                            <text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8,color:"#000" }}>{subcatName}</text>
                                        </div>
                                        {/* Render services below */}
                                        {
                                            isMobileView ?
                                            filteredSubcategoryServicesMap[subcatName].map((service, sIdx) => (
                                               
                                                isMobileView ?
                                                    <div className='proCardWidth_sv2'>
                                                        <NewServiceCard state={state} serviceData={service} onPressCard={() => NavToserviceDetails_Mobile(service)} />
                                                    </div> :
    
                                                    <div className='proCardWidth_sv2'>
                                                        <NewServiceCard state={state} serviceData={service} onPressCard={() => serviceDetailsModalShow(service)} />
                                                    </div>
                                                
                                            ))
                                            :
                                            <div className='serviceCardsContainer'>
                                                {
                                                    filteredSubcategoryServicesMap[subcatName].map((service, sIdx) => (
                                                        <div className='proCardWidth_sv2'>
                                                            <NewServiceCard state={state} serviceData={service} onPressCard={() => serviceDetailsModalShow(service)} />
                                                        </div>
                                                        
                                                    ))
                                                }
                                            </div>

                                        }

                                        <div style={{ marginBottom: 24 }} />
                                    </div>
                                ))
                                :
                                null
                            }
                        </>
                </div>
                <>
                    <BookAserviceWithUs />
                </>
            </>
            }

        {serviceDetailsModal && serviceDetailsDisplayModal}
        </div>


    )
}
